import React from 'react';
import { Copy, Stack, Squish, Flex } from '@grubhubprod/gh-cookbook-react';
import { getErrorMessage } from 'src/components/CSVUploadTracking/CSVUploadTracking.utils';

interface CSVUploadErrorBannerProps {
  fileName: string;
  areKnownErrorsExist: boolean;
  exceedsMaxErrors: boolean;
}

export function CSVUploadErrorBanner({
  fileName,
  areKnownErrorsExist,
  exceedsMaxErrors,
}: CSVUploadErrorBannerProps): JSX.Element {
  const errorMessage = getErrorMessage(areKnownErrorsExist, exceedsMaxErrors);

  return (
    <Stack y="sm">
      <Squish
        inset="lg"
        border="1px solid"
        borderColor="lineMedium"
        borderRadius="small"
      >
        <Flex flexDirection="column">
          <Stack x="xxx-sm">
            <Copy variant="body">{fileName}</Copy>
          </Stack>
          <Copy variant="body" color="danger">
            {errorMessage}
          </Copy>
        </Flex>
      </Squish>
    </Stack>
  );
}
